import axios from "axios"

export function updateBulkProduct(data) {
  return new Promise((resolve, reject) => {
    axios.post("/serialnumber/api/v1/product/bulk-update", data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}